import { Box, Grid, Typography } from "@mui/material";
import { motion } from "framer-motion";
import visionImg from "../../assets/image/landing/vision.png";
import missionImg from "../../assets/image/landing/mission.png";
import phFlagSilhouette from "../../assets/image/landing/prducts-banner.png";
import HolographicCard from "../animations/HolographicCard";

const StrategicGoalsSectionComponent = () => {

    const goalsData = [
        {
            id: "01",
            title: "Vision",
            description: "To become the leading local security, technology, and infrastructure provider in the Philippines, enhancing national security.",
            image: visionImg
        },
        {
            id: "02",
            title: "Mission",
            description: "Develop and deliver high-quality security systems, technologies, and infrastructure through strategic collaborations and innovation.",
            image: missionImg
        }
    ];

    return (
        <Box
            sx={{
                py: { xs: 8, md: 12 },
                px: { xs: 3, md: 10 },
                backgroundColor: '#08244d',
                backgroundImage: `url(${phFlagSilhouette})`,
                backgroundSize: 'cover',
                backgroundPosition: 'left center', // Keep 'left center' from Military or 'center' from Civilian? 'left center' anchors the flag.
                backgroundBlendMode: 'multiply',
                color: '#fff',
                position: 'relative',
                overflow: 'hidden'
            }}
        >
            <Box sx={{ textAlign: 'center', mb: 8, position: 'relative', zIndex: 2 }}>
                <Typography variant="h3" sx={{ fontWeight: 'bold', color: '#fff', mb: 2 }}>
                    Strategic Goals
                </Typography>
            </Box>

            <Box sx={{ position: 'relative', zIndex: 2 }}>
                {goalsData.map((item, index) => (
                    <Box key={index} sx={{ mb: { xs: 8, md: 15 } }}>
                        <Grid container spacing={{ xs: 4, md: 8 }} alignItems="center" direction={{ xs: 'column', md: index % 2 === 1 ? 'row-reverse' : 'row' }}>
                            {/* Image Side */}
                            <Grid item xs={12} md={6}>
                                <motion.div
                                    initial={{ opacity: 0, x: index % 2 === 0 ? -50 : 50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    viewport={{ once: true }}
                                    transition={{ duration: 0.8 }}
                                >
                                    <Box
                                        sx={{
                                            position: 'relative',
                                            height: { xs: 300, md: 450 },
                                            width: '100%',
                                            borderRadius: 4,
                                            overflow: 'hidden',
                                            boxShadow: '0 20px 40px rgba(0,0,0,0.3)',
                                            border: '1px solid rgba(255,255,255,0.1)'
                                        }}
                                    >
                                        <Box
                                            component="img"
                                            src={item.image}
                                            alt={item.title}
                                            sx={{
                                                width: '100%',
                                                height: '100%',
                                                objectFit: 'cover',
                                                transition: 'transform 0.5s',
                                                '&:hover': {
                                                    transform: 'scale(1.05)'
                                                }
                                            }}
                                        />
                                        {/* Overlay Gradient */}
                                        <Box sx={{
                                            position: 'absolute',
                                            top: 0,
                                            left: 0,
                                            width: '100%',
                                            height: '100%',
                                            background: 'linear-gradient(to bottom, rgba(0,0,0,0) 0%, rgba(8,36,77,0.4) 100%)',
                                        }} />

                                        {/* Floating ID */}
                                        <Typography variant="h1" sx={{
                                            position: 'absolute',
                                            bottom: 20,
                                            right: 20,
                                            fontWeight: '900',
                                            fontSize: { xs: '3rem', md: '5rem' },
                                            color: 'rgba(255, 255, 255, 0.2)',
                                            lineHeight: 0.8,
                                        }}>
                                            {item.id}
                                        </Typography>
                                    </Box>
                                </motion.div>
                            </Grid>

                            {/* Text Side */}
                            <Grid item xs={12} md={6}>
                                <motion.div
                                    initial={{ opacity: 0, x: index % 2 === 0 ? 50 : -50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    viewport={{ once: true }}
                                    transition={{ duration: 0.8, delay: 0.2 }}
                                >
                                    <Box sx={{
                                        textAlign: { xs: 'center', md: 'left' },
                                        p: { xs: 2, md: 4 },
                                        background: { xs: 'rgba(255,255,255,0.05)', md: 'none' },
                                        borderRadius: 4,
                                        backdropFilter: { xs: 'blur(10px)', md: 'none' }
                                    }}>
                                        <Typography variant="h3" sx={{
                                            fontWeight: 'bold',
                                            mb: 3,
                                            color: '#fff',
                                            textShadow: '0 0 20px rgba(79, 172, 254, 0.5)',
                                            fontSize: { xs: '2rem', md: '3rem' }
                                        }}>
                                            {item.title}
                                        </Typography>

                                        <Box sx={{
                                            width: 100,
                                            height: 4,
                                            backgroundColor: '#4facfe',
                                            mb: 4,
                                            borderRadius: 2,
                                            mx: { xs: 'auto', md: 0 }
                                        }} />

                                        <Typography variant="h5" sx={{
                                            color: '#e0e0e0',
                                            lineHeight: 1.8,
                                            fontWeight: '300',
                                            fontSize: { xs: '1.1rem', md: '1.3rem' }
                                        }}>
                                            {item.description}
                                        </Typography>
                                    </Box>
                                </motion.div>
                            </Grid>
                        </Grid>
                    </Box>
                ))}
            </Box>
        </Box>
    );
}

export default StrategicGoalsSectionComponent;
